import { EmailTemplate } from './emailTemplates.types'

export const EMAIL_TEMPLATES: EmailTemplate[] = [
    {
        id: 'kickoff',
        name: 'Kick Off',
        title: 'We Want to Hear From You About {{surveyTitle}}!',
        content: `Dear employee,

We want to hear from you! We're using <a href="https://diversio.com/" target="_blank">Diversio</a> to collect data on behalf of {{organizationName}}. Your input will help us strengthen our company culture! Please take a moment to respond by [DATE & TIME].

<b>Survey Description:</b>
{{surveyDescription}}

If you have any questions, thoughts, or suggestions, you can contact us here: [CONTACT INFO].

Survey link: <a href="{{surveyUrl}}" target="_blank">{{surveyUrl}}</a>

Thank you for your participation,
[YOUR NAME OR TEAM]`,
    },
    {
        id: 'followup',
        name: 'Follow Up',
        title: 'Friendly Reminder to Give Feedback on {{surveyTitle}}!',
        content: `Dear employee,

We still haven’t heard from you! We're using <a href="https://diversio.com/" target="_blank">Diversio</a> to collect data on behalf of {{organizationName}}. Your input will help us strengthen our company culture! Please take a moment to respond by [DATE & TIME].

<b>Survey Description:</b>
{{surveyDescription}}

If you have any questions, thoughts, or suggestions, you can contact us here: [CONTACT INFO].

Survey link: <a href="{{surveyUrl}}" target="_blank">{{surveyUrl}}</a>

Thank you for your participation,
[YOUR NAME OR TEAM]`,
    },
    {
        id: 'lastcall',
        name: 'Last Call',
        title: 'Last Chance to Fill Out {{surveyTitle}}!',
        content: `Dear employee,

Last chance to fill out the survey! We're using <a href="https://diversio.com/" target="_blank">Diversio</a> to collect data on behalf of {{organizationName}}. Your input will help us strengthen our company culture! Please take a moment to respond by [DATE & TIME].

<b>Survey Description:</b>
{{surveyDescription}}

If you have any questions, thoughts, or suggestions, you can contact us here: [CONTACT INFO].

Survey link: <a href="{{surveyUrl}}" target="_blank">{{surveyUrl}}</a>

Thank you for your participation,
[YOUR NAME OR TEAM]`,
    },
]

export const ANONIMITY_DISCLAIMER = `Please note that this survey is anonymous and your employer will not have access to your individual-level responses. They will only have access to aggregated data.`

export const replacePlaceholders = (template: string, placeholders: Record<string, string>): string => {
    return Object.entries(placeholders).reduce(
        (result, [key, value]) => result.replace(new RegExp(`{{${key}}}`, 'g'), value),
        template,
    )
}
